import React, { Component } from 'react';
import './index.css';

export default class Map extends Component {
  renderContent(images) {
    const props = {
      src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2712.0147122851076!2d27.615122915799972!3d47.17714852553797!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40cafc64285b0ecf%3A0xd13d84fceb1e3b13!2sIa%C8%99i+International+Airport!5e0!3m2!1sen!2sro!4v1489930635262",
      frameBorder: "0",
      allowFullScreen: true
    };

    return <iframe {...props}></iframe>;
  }

  render() {
    const rendered = this.renderContent();

    return (
      <div className="comp-map">
        {rendered}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/map/index.js